import { render } from "./LoadingButton.vue?vue&type=template&id=2f9dc73e&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import "./LoadingButton.vue?vue&type=style&index=0&id=2f9dc73e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9dc73e"]])

export default __exports__